/** UI chrome for match feed feature preview on the landing page. */
export const MATCH_FEED_PREVIEW = {
  title: 'Jobs ranked for you — with reasons why',
  updatedAgo: 'Updated 6h ago',
  filterAllMatches: 'All matches',
  filterStrongFit: 'Strong fit',
  filterRemote: 'Remote',
  filterNewToday: 'New today',
  rankedCount: '{{count}} ranked',
  scoredWhileYouSleep: 'Checked while you were away',
  initializingPipeline: 'Finding matches…',
  whyThisJob: 'Why this job for you?',
  matchLabel: 'Match',
  bandStrongFit: 'Strong fit',
  bandGoodFit: 'Good fit',
  bandPartialFit: 'Partial fit',
  basedOnSkills: 'Based on skills, experience & location.',
  whyYouMatch: "Why you're a match",
  skillsYouHave: 'Skills you have',
  skillGaps: 'Skill gaps',
  dimSkillOverlap: 'Skill overlap',
  dimSemanticFit: 'Semantic fit',
  dimExperience: 'Experience',
  dimSalaryFit: 'Salary fit',
  dimLocation: 'Location',
  dimRecency: 'Recency',
  dimScoringTitle: 'How we score each fit',
  nextStepsLabel: 'Next steps',
  btnOptimize: 'Optimize',
  btnApply: 'Apply',
  pipelineStep1: 'Reading your skills and experience',
  pipelineStep2: 'Scanning new job postings',
  pipelineStep3: 'Scoring fit across skills, salary, and location',
  pipelineStep4: 'Ranking the best matches for you',
  pipelineStep5: 'Writing match explanations',
  sampleWhy:
    'Your 6+ years in B2B SaaS and roadmap ownership align strongly with this remote PM role — high skill overlap and location fit.',
  feedJob1Title: 'Senior Product Manager',
  feedJob1Company: 'Microsoft',
  feedJob1Location: 'Remote',
  feedJob1Exp: 'Senior · 6+ yrs',
  feedJob1Salary: '₹35L – ₹48L',
  feedJob1Skills: 'Roadmaps|B2B SaaS|Analytics|SQL|Azure',
  feedJob1Description:
    'Drive cloud platform roadmap and partner with enterprise customers on quarterly priorities.',
  feedJob1MatchedSkills: 'Product Strategy|Roadmaps|B2B SaaS|SQL|Analytics',
  feedJob1MissingSkills: 'Azure platform certs',
  feedJob1BonusSkills: 'A/B Testing|Mixpanel',
  feedJob1ActionItems: 'Optimize resume for this JD|Draft a tailored cover letter|Apply via LinkedIn Easy Apply',
  feedJob2Title: 'Product Manager — Platform',
  feedJob2Company: 'Stripe',
  feedJob2Location: 'Bengaluru',
  feedJob2Exp: 'Mid-Senior · 5–8 yrs',
  feedJob2Salary: '₹32L – ₹42L',
  feedJob2Skills: 'Platform|APIs|GTM|Payments',
  feedJob2Why:
    'Platform PM experience maps very well; fintech domain is a minor stretch you can address in your summary.',
  feedJob2MatchedSkills: 'Platform|GTM|APIs',
  feedJob2MissingSkills: 'Payments domain depth',
  feedJob2BonusSkills: 'Analytics|Roadmaps',
  feedJob2ActionItems: 'Highlight platform launches|Apply on company portal',
  feedJob3Title: 'Lead PM – Growth',
  feedJob3Company: 'Razorpay',
  feedJob3Location: 'Bangalore',
  feedJob3Exp: 'Lead · 7+ yrs',
  feedJob3Salary: '₹30L – ₹38L',
  feedJob3Skills: 'Growth|GTM|0→1|Analytics',
  feedJob3Why:
    'Growth-loop experience from your SaaS role transfers cleanly; payments vertical is learnable.',
  feedJob3MatchedSkills: 'GTM|Analytics|0→1',
  feedJob3MissingSkills: 'Fintech compliance',
  feedJob3BonusSkills: 'Roadmaps',
  feedJob3ActionItems: 'Emphasize growth metrics|Request intro via Peerlist',
  feedJob4Title: 'Staff Product Manager',
  feedJob4Company: 'Freshworks',
  feedJob4Location: 'Chennai · Hybrid',
  feedJob4Exp: 'Staff · 8+ yrs',
  feedJob4Skills: 'Enterprise|APIs|Vision',
  feedJob4Why:
    'Enterprise PM scope fits your background; Chennai hybrid is a partial location match.',
  feedJob4MatchedSkills: 'Enterprise|APIs',
  feedJob4MissingSkills: 'Compliance frameworks|Multi-year vision docs',
  feedJob4BonusSkills: 'Roadmapping',
  feedJob4ActionItems: 'Save for later review|Watch for remote variant',
} as const;

export type MatchFeedPreviewCopy = typeof MATCH_FEED_PREVIEW;
